<form [formGroup]="searchByLocationForm" (ngSubmit)="submitSearchByLocation()">
  <div id="searchByZip" class="pad-top-20">
    <div class="row">
      <div class="column twelve pad-bottom-5">
        <ds-form-control-container
          [labelText]="'Address'"
          [control]="searchByLocationForm.controls['line1']"
          class="pad-top-20"
        >
          <input
            data-cy="drpSearchByLocationAddress"
            type="text"
            id="line1"
            class="fill"
            formControlName="line1"
            autocomplete="off"
          />
          <drp-autofill-dropdown
            [addressGuesses]="predictions"
            (userSelectedAddress)="onPredictionSelect($event)"
          >
          </drp-autofill-dropdown>
        </ds-form-control-container>
      </div>
      <div class="column six pad-bottom-5 pad-right-10">
        <ds-form-control-container
          [labelText]="'City'"
          [control]="searchByLocationForm.controls['city']"
        >
          <input
            data-cy="drpSearchByLocationCity"
            type="text"
            id="city"
            class="fill"
            formControlName="city"
            #city
            autocomplete="off"
          />
        </ds-form-control-container>
      </div>
      <div class="column six pad-bottom-5">
        <ds-form-control-container
          [labelText]="'State'"
          [control]="searchByLocationForm.controls['state']"
        >
          <select
            data-cy="drpSearchByLocationState"
            id="location-state"
            class="fill icon"
            formControlName="state"
            #state
            autocomplete="off"
          >
            <option value=""></option>
            @for (state of states; track state) {
              <option value="{{ state }}">{{ state }}</option>
            }</select
          ><span class="icon-chevron-down"></span>
        </ds-form-control-container>
      </div>
    </div>
    <div class="column six pad-right-10">
      <ds-form-control-container
        [labelText]="'ZIP Code'"
        [control]="searchByLocationForm.controls['zip']"
        [validateOnSubmit]="submitted"
      >
        <input
          data-cy="drpSearchByLocationZip"
          type="text"
          id="zip"
          class="fill"
          formControlName="zip"
          #zip
          autocomplete="off"
        />
        <span id="icon-find" class="icon-find"></span>
        <ds-form-control-message
          [control]="searchByLocationForm.controls['zip']"
          [validateOnSubmit]="submitted"
        >
        </ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column six">
      <ds-form-control-container
        [labelText]="'Distance'"
        [control]="searchByLocationForm.controls['distance']"
      >
        <select
          data-cy="drpSearchByLocationDistance"
          id="distance"
          class="fill icon"
          formControlName="distance"
          autocomplete="off"
        >
          @for (distance of distances; track distance) {
            <option value="{{ distance.value }}">
              {{ distance.label }}
            </option>
          }</select
        ><span class="icon-chevron-down"></span>
      </ds-form-control-container>
    </div>
    <button
      data-cy="drpSearchByLocationButton"
      ds-button
      class="column twelve input-offset"
      type="submit"
      [disabled]="!searchByLocationForm.valid"
    >
      Search
    </button>
  </div>
</form>
